import { z } from "zod";
import { SiteSchema } from "../site/SiteSchema";
import { dateRequired } from "../event/EventSchema";

export const  QASchema = z.object({
  Id: z.number().optional(),
  PlenumId: z.number().optional(),
  EventId: z.string().uuid().optional(),
  Active: z.boolean().default(false),
  Live: z.boolean().default(false),
  AllowUpvote: z.boolean().default(false),
  IsAnonymous: z.boolean().default(false),
  AutoApprove: z.boolean().default(false),
  NameRequired: z.boolean().default(false),
  MediaRequired: z.boolean().default(false),
  Title: z.string().optional(),
  Description: z.string().optional(),
  ModeratorPassword: z.string().optional(),
  VoteCount: z.number().optional()
});

export const  PlenumFrameSchema = z.object({
  Id: z.number().optional(),
  PlenumLanguageId: z.number().optional(),
  IsPrimaryContent: z.boolean().default(  false),
  PositionID: z.number().optional(),
  ConnTypeId: z.number().optional(),
  Source: z.string().optional(),
  AllInOne: z.boolean().default(false),
  HlsDelay: z.number().optional(),
  HlsDelayExtern: z.number().optional(),
  FB_ConnTypeId:z.number().optional(),
  FB_Source: z.string().optional(),
  FB_AllInOne: z.boolean().default(false),
  FB_UserToggleAuto: z.boolean().default(false),
  FB_UserToggleAllow: z.boolean().default(false),
  Director_ConnTypeId: z.number().optional(),
  Director_Source: z.string().optional()
});
export const PlenumLanguageSchema  = z.object({
  Id: z.number().optional(),
  PlenumId: z.number().optional(),
  Language: z.string().optional(),
  VideoServer: z.string().optional(),
  BridgeId: z.string().optional(),
  Pin: z.string().optional(),
  TextChatroomId: z.number().optional(),
  VODMedia: z.string().optional(),
  VODHasRecordings: z.boolean().default(false ),
  VODDelay:z.number().optional(),
});
export const PlenumSchema = z.object({
  Id: z.number().optional(),
  EventId: z.string().uuid().optional().nullable(),
  Languages: z.string().optional().nullable(),
  JoinPerPhone: z.boolean().optional().default(false),
  JoinPerWebAudio: z.boolean().optional().default(false),
  JoinPassive: z.boolean().optional().default(false),
  JoinPerCamera: z.boolean().optional().default(false),
  MatrixLimit: z.number().optional().nullable(),
  UserLimit: z.number().optional().nullable(),
  JoinPublic: z.boolean().optional().default(false),
  VideoBitrate: z.number().optional().nullable(),
  DateFrom: dateRequired,
  DateTo: dateRequired,
  NetworkingAreaId: z.number().optional().nullable(),
  Name: z.string().optional().nullable(),
  IsMarketplace: z.boolean().optional().default(false),
  VOD: z.boolean().optional().default(false),
  VODMedia: z.string().optional().nullable(),
  Live: z.boolean().optional().default(false),
  IsJitsi: z.boolean().optional().default(false),
  BackstageTCId: z.number().optional().nullable(),
  AgendaGroupID: z.string().optional().nullable(),
  HasPhotoWall: z.boolean().optional().default(false),
  JoinPerJitsi: z.boolean().optional().default(false),
  PredefineTRType: z.boolean().optional().nullable(),
  ShowDialogOnJoin: z.boolean().optional().default(false),
  VODHasRecordings: z.boolean().optional().default(false),
  EmojiTypes: z.string().optional().nullable(),
  TeamsLink: z.string().optional().nullable(),
  UserLimitTotal: z.number().optional().nullable(),
  JoinType: z.number().optional().default(0)

});
export const ExperienceSchema = z.object({
  Plenum: PlenumSchema,
  PlenumLanguages: z.array(PlenumLanguageSchema).optional().nullable().default([]),
  PlenumFrames: z.array(PlenumFrameSchema).optional().nullable().default([]),
  QandA: QASchema.optional().nullable()

});
export const PresentationKeySchema  = z.object({
  Id: z.number().optional(),
  PresentationId: z.number().optional(),
  Language: z.string().optional(),
  PathKey: z.string().optional(),
  TempFile: z.string().optional().nullable(),
  TOM: z.string().optional(),
});



export const PresentationSchema  = z.object({
  Id: z.number().optional(),
  PlenumId: z.number().optional(),
  EventId: z.string().uuid().optional().nullable(),
  Title: z.string(),
  Position: z.number().optional(),
  Type: z.string().optional(),
  PointerEvents: z.boolean().default(false),
  Keys: z.array(PresentationKeySchema).optional().nullable().default([])
});

export const SurveySchema  = z.object({
  Id: z.number().optional(),
  PlenumId: z.number().optional(),
  EventId: z.string().uuid().optional().nullable(),
  Name: z.string(),
  Data: z.string().optional(),
  Live: z.boolean().default(false),
  ResultViewOn: z.boolean().default(false),
  IsRedlofSurvey: z.boolean().default(true),
  IsAnonymous: z.boolean().default(false)
});

export type SurveyInfoSchema = {
  Id?:  number;
  EventId?: string | null;
  PlenumId?: number;
  Name: string;
  Live: boolean;
  ResultViewOn: boolean;
  IsRedlofSurvey: boolean;
  
};

export type PlenumInfoSchema = {
  Id?:  number;
  EventId?: string | null;
  JoinPerPhone?: boolean;
  JoinPerWebAudio?: boolean;
  JoinPassive?: boolean;
  JoinPerCamera?: boolean;
  MatrixLimit?: number | null;
  UserLimit?: number | null;
  JoinPublic?: boolean;
  VideoBitrate?: number | null;
  DateFrom?: string | null;
  DateTo?: string | null;
  NetworkingAreaId?: string | null;
  Name?: string;
  IsMarketplace?: boolean;
  VOD?: boolean;
  VODMedia?: string | null;
  Live?: boolean;
  IsJitsi?: boolean;
  
  HasQandA?: boolean;
  QandALive?: boolean;
  JoinModes?: string;
  DateFrom_date?: string | null;
  DateTo_date?: string | null;
  JoinMode?: string;
  QA?: boolean;
  QAndA?: boolean;
};
